import React from 'react';
import STRINGS from './../../data/language/language';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';

class EsqueceuSenha extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      strings: STRINGS[window.LANGUAGE]
    }

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  componentDidMount(){
  }

  handleSubmit(event) {
    event.preventDefault();

    const email = this.state.email;

    var self = this;

    const {
      atencao,
      digiteEmail,
      erroGeral
    }
    = this.state.strings;

    if(!email){
      var msg = {
        title: atencao,
        text: digiteEmail
      };

      Dialog.create(msg);
      return false;
    }

    Requisitions({
      callLoader: (visible) => self.setLoaderVisible(visible),
        url: WS.recuperar,
        data: { email },
        sucess: data => {
          var msg = {
            title: atencao,
            text: data.msg
          };

          Dialog.create(msg);
        },
        error: () => {
          Dialog.create(
            atencao,
            erroGeral
          );
        },
        complete: () => {}
      });
  }


  render() {
    return (
      <div className="" >
        <h5 className='title-esqueceu-senha'>{this.state.strings.titleEsqueceuSenha}</h5>
        <p className='msg-esqueceu-senha'>{this.state.strings.msgEsqueceuSenha}</p>
        <form className="form-esqueceu-senha"  onSubmit={this.handleSubmit}>
        <div className='pure-u-g'>
          <div className='pure-u-1'>
            <TextInput onChange={this.handleInputChange} name="email" title="Email" placeholder="Digite o email"></TextInput>
          </div>
        </div>
        <Button type="submit" text="Enviar" classes="button-login simple-button" />
        </form>

      </div>
    );
  }
}

export default EsqueceuSenha;



// WEBPACK FOOTER //
// ./src/classes/login/EsqueceuSenha.js